import React from "react";
import { cn } from "@/utils/cn";

interface SectionProps {
  children: React.ReactNode;
  className?: string;
}

export const Scrollable: React.FC<SectionProps> = ({ children, className }) => {
  return (
    <div className={cn("flex-1 overflow-y-auto", className)}>
      {children}
    </div>
  );
};

export const Padded: React.FC<SectionProps> = ({ children, className }) => {
  return (
    <div className={cn("px-4 lg:px-6 py-4 lg:py-6", className)}>
      {children}
    </div>
  );
};

export const Full: React.FC<SectionProps> = ({ children, className }) => {
  return (
    <div className={cn("flex-1 overflow-hidden", className)}>
      {children}
    </div>
  );
};

export const Card: React.FC<SectionProps> = ({ children, className }) => {
  return (
    <div className="flex-1 min-h-0 px-4 lg:px-6 pb-4 lg:pb-6">
      <div className={cn("bg-white rounded-lg h-full flex flex-col overflow-y-auto", className)}>
        {children}
      </div>
    </div>
  );
};

/**
 * Canvas — the card-less section for pages whose items carry their own
 * card chrome (idea/post/media/brief cards). The page canvas holds the
 * grid directly; no white wrapper container (DD-008).
 */
export const Canvas: React.FC<SectionProps> = ({ children, className }) => {
  return (
    <div className="flex-1 min-h-0 px-4 lg:px-6 pb-4 lg:pb-6">
      <div className={cn("h-full flex flex-col overflow-y-auto", className)}>
        {children}
      </div>
    </div>
  );
};
